import { render, staticRenderFns } from "./AreaIndex.vue?vue&type=template&id=7309ced9&"
import script from "./AreaIndex.vue?vue&type=script&lang=js&"
export * from "./AreaIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports